import { render, staticRenderFns } from "./plusAddWallet.vue?vue&type=template&id=0a09543a&"
import script from "./plusAddWallet.vue?vue&type=script&lang=js&"
export * from "./plusAddWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports